import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Availability, GungModalService, Product, ProductInputQuantityConfigService, SimplifiedAvailability } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class TyloProductInputQuantityConfigService extends ProductInputQuantityConfigService {

  constructor(
    protected gungModalService: GungModalService,
    protected translateService: TranslateService
  ) {
    super();
  }

  getAllowPurchaseOverAvailability(quantity: number, availability: Availability | SimplifiedAvailability, product: Product, roles: string[]): boolean {
    const alertMessage = `
    <div>
      <p>${this.translateService.instant('AVAILABLE_NUMBER_EXCEEDED_ALERT')}</p>
    </div>`
    if (product && product.extra.ar.itemstatuscode === 7 && quantity > availability?.maxFutureStock) {
      this.gungModalService.openBasicModal(null, alertMessage, { size: 'lg' }).then(
        result => {},
        reason => {}
      );
      return false;
    }
    return true;
  }
}
